import { FC, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import styles from './AdvancedSearchBar.module.scss';

const AdvancedSearchBar: FC = () => {
  const router = useRouter();

  const refSearchField = useRef<HTMLDivElement>(null);

  const isAuthorPage = router.asPath.includes('/search/author/');

  const [inputSearch, setInputSearch] = useState('');
  const [isAuthorSearch, setIsAuthorSearch] = useState(isAuthorPage);

  const getSearchWord = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearch(event.target.value);
  };

  const searchByPressEnter = (event: React.KeyboardEvent<object>) => {
    if (String(event.code) == 'Enter') {
      router.push(`/search/${isAuthorSearch ? 'author' : 'book'}/${searchWord}`);
    }
  };

  const searchWord = inputSearch.includes(' ') ? inputSearch.split(' ').join('+') : inputSearch;

  return (
    <>
      <div className={styles.advancedSearchBar} ref={refSearchField}>
        <div className={styles.advancedSearchBar__row}>
          <div className={`${styles.advancedSearchBar__input} ${styles.formInput} ${styles.formInput_mb}`}>
            <input className={styles.input} value={inputSearch} onChange={getSearchWord} placeholder="Поиск..." onKeyDown={searchByPressEnter} />
          </div>

          <div className={styles.advancedSearchBar__controls}>
            <span className={styles.advancedSearchBar__controlsTxt}>Поиск</span>
            <div className={styles.advancedSearchBar__radios}>
              <div className={styles.radio}>
                <label className={styles.radio__label}>
                  <input className={styles.radio__input} name="type" type="radio" defaultChecked={!isAuthorPage} onChange={() => setIsAuthorSearch(false)} />
                  <span className={styles.radio__btn}></span> По книге
                </label>
                <label className={styles.radio__label}>
                  <input className={styles.radio__input} name="type" type="radio" defaultChecked={isAuthorPage} onChange={() => setIsAuthorSearch(true)} />
                  <span className={styles.radio__btn}></span> По автору
                </label>
              </div>
            </div>
            {!!inputSearch.length ? (
              <Link prefetch={false} href={`/search/${isAuthorSearch ? 'author' : 'book'}/${searchWord}`} className={styles.advancedSearchBar__btn}>
                Найти
              </Link>
            ) : (
              <span className={styles.advancedSearchBar__btn}>Найти</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvancedSearchBar;
